import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/contexts';
import { supabase } from '../../../../lib/clients/supabase';
import { toast } from 'sonner';
import './UserProfile.css';


const UserProfile = () => {
    const navigate = useNavigate();
    const { currentUser, userFirstName, userLastName, signOut } = useAuth();

    const handleDeleteAccount = () => {
        toast('Are you sure you want to delete your account? This action cannot be undone and will delete all your data including booking history.', {
            action: {
                label: 'Delete Account',
                onClick: async () => {
                    try {
                        // Delete user profile from database - this will trigger the cascade deletion
                        const { error: profileError } = await supabase
                            .from('profiles')
                            .delete()
                            .eq('id', currentUser.id);

                        if (profileError) {
                            console.error('Error deleting profile:', profileError);
                            toast.error('Failed to delete account. Please try again or contact support.');
                            return;
                        }

                        // If we get here, the deletion was successful
                        toast.success('Your account has been successfully deleted.');
                        await signOut();
                        navigate('/');
                    } catch (error) {
                        console.error('Error deleting account:', error);
                        toast.error('Failed to delete account. Please try again or contact support.');
                    }
                }
            },
            cancel: {
                label: 'Cancel'
            }
        });
    };

    return (
        <div className="user-profile__card">
            <h2 className="user-profile__card-title">Profile Information</h2>
            <div className="user-profile__profile">
                <p className="user-profile__profile-item">
                    <span>Name:</span> {`${userFirstName} ${userLastName}`}
                </p>
                <p className="user-profile__profile-item">
                    <span>Email:</span> {currentUser?.email}
                </p>
                <div className="user-profile__profile-actions">
                    <button
                        className="user-profile__delete-account"
                        onClick={handleDeleteAccount}
                    >
                        Delete Account
                    </button>
                </div>
            </div>
        </div>
    )
}

export default UserProfile;